export default __webpack_public_path__ + "static/media/background.d3862a28.jpg";